import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";
import { ModelProvider } from "./model.tsx";
import { decoderReady } from "./scanner.ts";
import "./styles/base.css";
import "./styles/app.css";

// Start the decoder's wasm fetch before React mounts, so the first frame the camera produces has
// something to decode with instead of waiting on a download.
void decoderReady;

const host = document.getElementById("root");
if (host === null) throw new Error("#root is missing from index.html");

// No StrictMode on purpose: its double-invoked effects would open the camera twice and POST a
// second basket on every mount, which is a real cost against a real server, not a lint warning.
createRoot(host).render(
	<ModelProvider>
		<App />
	</ModelProvider>,
);

if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err: unknown) => {
			// A failed registration costs the offline shell, nothing else; the app still runs.
			console.warn("service worker registration failed", err);
		});
	});
}
